// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"1fe98cb7","453":"6fa125bf"}[chunkId] + ".chunk.js";
};